import styled from 'styled-components';
import Radio from '@material-ui/core/Radio';

import THEME from '../../../../../../constants/theme';

export const TableContainer = styled.div`
  margin-top: 32px;
  & .ReactTable .rt-thead .rt-th:last-child {
    text-align: left;
  }
  & .ReactTable .rt-thead .rt-th:first-child {
    text-align: left;
  }
  & .ReactTable .rt-tr-group {
    padding: 0px;
  }

  & .ReactTable .rt-tbody .rt-tr-group:first-child {
    border-top: 1px solid #efefef;
  }
  & .ReactTable .rt-tbody .rt-tr-group:last-child {
    border-bottom: 1px solid #efefef;
  }

  & .ReactTable .rt-tr  {
    height: 54px;
  }
  & .ReactTable .rt-td {
    padding-top: 0px;
    padding-bottom: 0px;
  }
`;

export const TableHeader = styled.div`
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  align-items: center;
  text-align: center;
  color: ${THEME.bobBlack};
}

`;
export const TableText = styled.div`
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  align-items: center;
  text-align: center;
  color: ${THEME.bobBlack};
`;

export const TableDateContainer = styled(TableText)`
  margin-top: 0;
`;

export const StyledRadio = styled(Radio)`
  color: ${THEME.primary} !important;
`;

export const StyledDateP = styled.p`
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ErrorText = styled.div`
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: ${THEME.error};
`;
